module.exports = __webpack_public_path__ + "img/质量管理体系认证证书.c3f7eb6a.jpg";